import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.yang = bracketIndenting()
